import ObjectTypeAndColumnNamePicker from './components/ObjectTypeAndColumnNamePicker';
import ChatBulkAuditCreationCompass from './components/ChatBulkAuditCreationCompass';
import {
  CompassCardComponent,
  CompassCardComponentProps,
} from 'react-scale/corp/views/DataCompassV2/types';
import useChatBulkAuditCard from './useChatBulkAuditCard';

const ChatBulkAuditCardComponent: CompassCardComponent = (
  cardComponentProps: CompassCardComponentProps,
) => {
  const { index } = cardComponentProps;

  const {
    auditName,
    setAuditName,
    objectIdsColumnName,
    setObjectIdsColumnName,
    objectType,
    setObjectType,
    shouldClaimTasks,
    setShouldClaimTasks,
    projectId,
    setProjectId,
    limit,
    setLimit,
  } = useChatBulkAuditCard(index);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
      <ObjectTypeAndColumnNamePicker
        cardComponentProps={cardComponentProps}
        selectedObjectType={objectType}
        setSelectedObjectType={setObjectType}
        selectedColumnWithObjectIds={objectIdsColumnName}
        setSelectedColumnWithObjectIds={setObjectIdsColumnName}
      />

      <ChatBulkAuditCreationCompass
        projectId={projectId}
        setProjectId={setProjectId}
        selectedObjectType={objectType}
        auditName={auditName ?? ''}
        setAuditName={setAuditName}
        shouldClaimTasks={shouldClaimTasks ?? false}
        setShouldClaimTasks={setShouldClaimTasks}
        limit={limit}
        setLimit={setLimit}
      />
    </div>
  );
};

export default ChatBulkAuditCardComponent;
